import ParentalConsent from "./ParentalConsent";
import { ParentalConsentProps, ParentalConsentRequest } from "./ParentalConsent";
export default ParentalConsent
export type { ParentalConsentProps, ParentalConsentRequest }